import * as React from "react"
import tw from "twin.macro"
import styled from "@emotion/styled"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-black opacity-75`

const HeroContainer = styled.div`
  min-height: 24rem;

  ${tw`z-20 relative px-6 sm:px-8 mx-auto h-full flex flex-col`}
`
const Content = tw.div`px-4 flex flex-1 flex-col justify-center items-center`

const Heading = styled.h1`
  ${tw`text-3xl text-center sm:text-4xl lg:text-5xl xl:text-6xl font-black text-gray-100 leading-snug -mt-24 sm:mt-0 mb-12`}
  span {
    ${tw`inline-block mt-2`}
  }
`

const Subheading = styled.p`
  ${tw`text-xl text-center font-medium text-blue-300 leading-snug max-w-4xl mx-auto mt-6 leading-relaxed`}
`

export default () => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "projects_hero_bg.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <div tw="relative">
      <div tw="z-10 absolute inset-0">
        <Img
          fluid={data.file.childImageSharp.fluid}
          style={{ width: "100%", height: "100%" }}
        />
      </div>
      <OpacityOverlay />
      <HeroContainer>
        <Content>
          <Heading>Projects</Heading>
        </Content>
      </HeroContainer>
    </div>
  )
}
